import { AfterViewInit, Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormService } from '../form.service';
import { BaseControlValueAccessorComponent } from '../inputs/base-control-value-accessor/base-control-value-accessor.component';
import { validatePattern } from '../validators/custom-validators';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneInputComponent),
      multi: true,
    },
  ],
})
export class PhoneInputComponent extends BaseControlValueAccessorComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() placeholder: string | undefined = 'Telefonszám';
  @Input() formControl = new UntypedFormControl();
  @Input() countryCode = '';
  @Input() phoneRegex = '';
  @Input() required = false;
  @Input() width = 50;
  @ViewChild('phoneNumberInput', { static: true }) phoneNumberInput: ElementRef;
  private readonly subscriptions: Subscription[] = [];
  public telephoneForm: UntypedFormGroup;

  constructor(public readonly formService: FormService, private readonly formBuilder: UntypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.initializePhoneForm();
  }

  ngAfterViewInit(): void {
    if (this.telephoneForm && this.telephoneForm.get('countryCode')) {
      const countryCodeControl = this.telephoneForm.get('countryCode');
      if (countryCodeControl) {
        const subscription = countryCodeControl.valueChanges.subscribe((cc) => {
          if (cc === '36' || cc.length === 3) {
            this.phoneNumberInput.nativeElement.focus();
          }
        });
        if (subscription) {
          this.subscriptions.push(subscription);
        }
      }
    }

    this.subscriptions.push(
      this.telephoneForm.valueChanges.subscribe((val) => {
        if (this.telephoneForm.valid) {
          this.formControl.setValue(`${val.countryCode} ${val.phoneNumber}`);
        } else {
          this.formControl.setValue(null);
        }
      })
    );
  }
  private initializePhoneForm(): void {
    if (this.countryCode) {
      if ((this.countryCode as string).startsWith('/')) {
        this.countryCode = (this.countryCode as string).slice(1);
      }
      if ((this.countryCode as string).endsWith('/')) {
        this.countryCode = (this.countryCode as string).slice(0, -1);
      }
    }
    let countryCode = '';
    let phoneNumber = '';
    if (this.formControl.value) {
      const values = this.formControl.value.split(' ');
      countryCode = values[0];
      phoneNumber = values[1];
    }
    this.telephoneForm = this.formBuilder.group({
      countryCode: [countryCode, [validatePattern(this.countryCode)]],
      phoneNumber: [phoneNumber, [validatePattern(this.phoneRegex)]],
    });

    if (this.required) {
      this.placeholder = `${this.placeholder} *`;
      this.telephoneForm.get('countryCode')?.addValidators(Validators.required);
      this.telephoneForm.get('phoneNumber')?.addValidators(Validators.required);
      this.telephoneForm.updateValueAndValidity();
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
